<template>
	<v-card 
		class="text-center mx-auto"
		:max-width="maxWidth"
		:width="width"
		flat
	>
		<v-card-item>
			<v-card-title :class="titleClass">
				{{ title }}
			</v-card-title>
			<v-card-subtitle :class="subtitleClass">
				{{ subtitle }}
			</v-card-subtitle>
		</v-card-item>

		<v-card-text>
			{{ text }}
		</v-card-text>
		
		<v-card-text>
			<v-form ref="form">
				<v-text-field
					v-model="value.phone"
					label="Нормер телефону"
					placeholder="+38 ХХХ ХХХ ХХ ХХ"
					variant="outlined"
					:rules="[rules.required,rules.phone]"
					@keydown.ctrl.z="item.ApplicantPhone='+380963332211'"
				></v-text-field>
			</v-form>
		</v-card-text>
	</v-card>
</template>

<script>
import mixin from './mixin/main'

export default {
	mixins: [mixin]
}
</script>
